/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import remove from '../../../../../Res/Icon/remove.png';
import executeProvision from '../../../../../Res/Icon/executeProvision.svg';
import './BoxObi.css';
import { unAssignAta, setBoxDetailsData } from '../../../../../actions/EpikBoxes';
import { toast } from 'react-toastify';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import { useUnifiedMutate } from '../../../../../hooks/useUnifiedMutate';

const ExternalAta = props => {
  const token = localStorage.getItem('jwtToken') || null;

  const { selected, active, enableBoxEdit, box, boxTrigger } = props;
  const dispatch = useDispatch();
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const containerClassName = selected ? 'boxObiContainer grandstream-ata selected' : 'boxObiContainer grandstream-ata';

  const [dataFetched, setDataFetched] = useState(false);
  const { mutate: provisionGSATA, isLoading: provisionLoading } = useUnifiedMutate();

  useEffect(() => {
    if (token && box && !dataFetched) {
      dispatch(setBoxDetailsData(token, box));
      setDataFetched(true);
    }
  }, [token, box, dispatch, dataFetched]);

  const onExternalAtaRemove = async () => {
    const externalId = boxDetails?.externalAta[0]._id;
    const result = await dispatch(unAssignAta(token, externalId));
    if (result) {
      boxTrigger(true);
      toast.success('External ATA removed successfully!');
    }
  };

  const onProvisionNow = async () => {
    const macAddress = boxDetails?.externalAta[0]?.macAddress;
    if (!macAddress || !boxDetails?._id) {
      toast.error('Missing MAC address or box ID');
      return;
    }
    
    const endpoint = `obis/${boxDetails._id}/provisionGSATA/${macAddress}`;
    const response = await provisionGSATA({
      isMyEpik: false,
      endpoint,
      method: 'PUT',
      body: null,
    });
    
    if (response?.response) {
      toast.success(response?.response);
    }
  };

  const activeBtnStyle = {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
  };
  return (
    <>
      <div className={containerClassName} onClick={() => null}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            paddingLeft: '5px',
            paddingTop: '2px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                position: 'relative',
              }}
            >
              {active ? (
                <div
                  style={{
                    ...activeBtnStyle,
                    background: '#0cd60c',
                  }}
                />
              ) : (
                <div
                  style={{
                    ...activeBtnStyle,
                    background: '#ffc107',
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div>
          <strong>External FXS</strong>
        </div>
        <div className="obiInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="microchip" />
            <h5>MAC Address</h5>
          </div>
          <span>{boxDetails?.externalAta[0]?.macAddress || 'N/A'}</span>
        </div>
        <div className="epi-footer">
          <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }} id={'provision-now-external'}>
            {provisionLoading ? (
              <SpinnerCircles red={true} />
            ) : null}
            <div hidden={provisionLoading}>
              <TooltipIcon
                tipId={'provision-now-external'}
                onClick={onProvisionNow}
                imgSrc={executeProvision}
                displayData="Provision Now"
                placement="top"
                customClass="epi-info"
                customStyle={{
                  position: 'relative',
                  top: '3px',
                  height: '20px',
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="delete-box-icon"
        onClick={onExternalAtaRemove}
        style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }}
      >
        <img
          className="actions-icon"
          style={{
            position: 'relative',
            right: '2.5rem',
            top: '3px',
            height: '20px',
          }}
          src={remove}
          alt="remove"
        />
      </div>
    </>
  );
};

export default ExternalAta;
